<lib-titled-card>
  <h2>{{ constants.professionalReferences.cardTitle }}</h2>
  <p class="note" [innerHTML]="constants.professionalReferences.text"></p>

  <lib-read-field [value]="referenceCount">{{ constants.professionalReferences.dataPoint }}</lib-read-field>
</lib-titled-card>
